module.exports = __webpack_public_path__ + "img/bingo_ball-75.9741680e.png";